import React, { useState } from "react";
import css from "./Logout.module.css";
import exit from "./logout.svg";
import { SERVER_URL } from "../../config";

function Logout() {
  async function logoutUser() {
    const res = await fetch(`${SERVER_URL}/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    console.log(res);
  }

  return (
    <button onClick={logoutUser} className={css.logout}>
      <img src={exit} />
      Logout
    </button>
  );
}

export default Logout;
